export enum ThemeModes {
  dark = 'dark',
  light = 'light',
}
